export const HOME_BANNER =
  "https://images.unsplash.com/photo-1542810634-71277d95dcbb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const MAX_LEVEL = 3;
export const LEVEL_SIZE = 12;

export const CATEGORIES = [
  { key: "alphabet", title: "Letters", emoji: "🔤", color: "#3B82F6", shadow: "rgba(37,99,235,1)" },
  { key: "numbers", title: "Numbers", emoji: "🔢", color: "#EF4444", shadow: "rgba(185,28,28,1)" },
  { key: "animals", title: "Animals", emoji: "🐾", color: "#22C55E", shadow: "rgba(21,128,61,1)" },
  { key: "colors", title: "Colors", emoji: "🎨", color: "#A855F7", shadow: "rgba(126,34,206,1)" },
  { key: "words", title: "Simple Words", emoji: "💬", color: "#0EA5E9", shadow: "rgba(2,132,199,1)", premium: true },
  { key: "spanish", title: "Spanish", emoji: "🌎", color: "#F97316", shadow: "rgba(194,65,12,1)", premium: true },
  { key: "geography", title: "Geography", emoji: "🗺️", color: "#14B8A6", shadow: "rgba(13,148,136,1)", premium: true },
  { key: "grammar", title: "Grammar", emoji: "✏️", color: "#6366F1", shadow: "rgba(67,56,202,1)", premium: true },
  { key: "money", title: "Money Smarts", emoji: "💰", color: "#D97706", shadow: "rgba(146,64,14,1)", premium: true },
  { key: "team", title: "Team Building", emoji: "🤝", color: "#EC4899", shadow: "rgba(190,24,93,1)", premium: true },
  { key: "creativity", title: "Creativity Studio", emoji: "🎭", color: "#F43F5E", shadow: "rgba(190,18,60,1)", premium: true },
];

// Each category has 3 levels of 12 items. Higher levels are harder.
export const LEVELS = {
  alphabet: [
    [
      { k: "A", word: "Apple", emoji: "🍎" }, { k: "B", word: "Ball", emoji: "⚽" },
      { k: "C", word: "Cat", emoji: "🐱" }, { k: "D", word: "Dog", emoji: "🐶" },
      { k: "E", word: "Egg", emoji: "🥚" }, { k: "F", word: "Fish", emoji: "🐟" },
      { k: "G", word: "Goat", emoji: "🐐" }, { k: "H", word: "Hat", emoji: "🎩" },
      { k: "I", word: "Igloo", emoji: "🧊" }, { k: "J", word: "Jam", emoji: "🍓" },
      { k: "K", word: "Kite", emoji: "🪁" }, { k: "L", word: "Lion", emoji: "🦁" },
    ],
    [
      { k: "M", word: "Moon", emoji: "🌙" }, { k: "N", word: "Nest", emoji: "🪺" },
      { k: "O", word: "Owl", emoji: "🦉" }, { k: "P", word: "Pig", emoji: "🐷" },
      { k: "Q", word: "Queen", emoji: "👑" }, { k: "R", word: "Rabbit", emoji: "🐰" },
      { k: "S", word: "Sun", emoji: "☀️" }, { k: "T", word: "Tiger", emoji: "🐯" },
      { k: "U", word: "Umbrella", emoji: "☂️" }, { k: "V", word: "Van", emoji: "🚐" },
      { k: "W", word: "Whale", emoji: "🐳" }, { k: "X", word: "Xylophone", emoji: "🎹" },
    ],
    [
      { k: "a", word: "Ant", emoji: "🐜" }, { k: "b", word: "Bee", emoji: "🐝" },
      { k: "c", word: "Cup", emoji: "🥤" }, { k: "d", word: "Duck", emoji: "🦆" },
      { k: "e", word: "Elephant", emoji: "🐘" }, { k: "f", word: "Frog", emoji: "🐸" },
      { k: "g", word: "Grapes", emoji: "🍇" }, { k: "h", word: "House", emoji: "🏠" },
      { k: "i", word: "Ice", emoji: "🧊" }, { k: "j", word: "Juice", emoji: "🧃" },
      { k: "k", word: "Key", emoji: "🔑" }, { k: "l", word: "Leaf", emoji: "🍃" },
    ],
  ],
  numbers: [
    [
      { k: "1", word: "One", emoji: "🍎" }, { k: "2", word: "Two", emoji: "🍌" },
      { k: "3", word: "Three", emoji: "🍓" }, { k: "4", word: "Four", emoji: "🍊" },
      { k: "5", word: "Five", emoji: "⭐" }, { k: "6", word: "Six", emoji: "🐟" },
      { k: "7", word: "Seven", emoji: "🌸" }, { k: "8", word: "Eight", emoji: "🎈" },
      { k: "9", word: "Nine", emoji: "🦋" }, { k: "10", word: "Ten", emoji: "🍇" },
      { k: "11", word: "Eleven", emoji: "🌟" }, { k: "12", word: "Twelve", emoji: "🍩" },
    ],
    [
      { k: "13", word: "Thirteen", emoji: "🔵" }, { k: "14", word: "Fourteen", emoji: "🟢" },
      { k: "15", word: "Fifteen", emoji: "🟡" }, { k: "16", word: "Sixteen", emoji: "🔴" },
      { k: "17", word: "Seventeen", emoji: "🟣" }, { k: "18", word: "Eighteen", emoji: "🟠" },
      { k: "19", word: "Nineteen", emoji: "⚪" }, { k: "20", word: "Twenty", emoji: "🟤" },
      { k: "21", word: "Twenty One", emoji: "🔶" }, { k: "22", word: "Twenty Two", emoji: "🔷" },
      { k: "23", word: "Twenty Three", emoji: "🔸" }, { k: "24", word: "Twenty Four", emoji: "🔹" },
    ],
    [
      { k: "25", word: "Twenty Five", emoji: "🟩" }, { k: "26", word: "Twenty Six", emoji: "🟦" },
      { k: "27", word: "Twenty Seven", emoji: "🟨" }, { k: "28", word: "Twenty Eight", emoji: "🟥" },
      { k: "29", word: "Twenty Nine", emoji: "🟪" }, { k: "30", word: "Thirty", emoji: "🟧" },
      { k: "40", word: "Forty", emoji: "⬛" }, { k: "50", word: "Fifty", emoji: "⬜" },
      { k: "60", word: "Sixty", emoji: "🟫" }, { k: "70", word: "Seventy", emoji: "🔺" },
      { k: "80", word: "Eighty", emoji: "🔻" }, { k: "100", word: "One Hundred", emoji: "💯" },
    ],
  ],
  colors: [
    [
      { k: "red", word: "Red", hex: "#EF4444" }, { k: "blue", word: "Blue", hex: "#3B82F6" },
      { k: "yellow", word: "Yellow", hex: "#FACC15" }, { k: "green", word: "Green", hex: "#22C55E" },
      { k: "orange", word: "Orange", hex: "#FB923C" }, { k: "purple", word: "Purple", hex: "#A855F7" },
      { k: "pink", word: "Pink", hex: "#EC4899" }, { k: "brown", word: "Brown", hex: "#92400E" },
      { k: "black", word: "Black", hex: "#0F172A" }, { k: "white", word: "White", hex: "#F1F5F9" },
      { k: "gray", word: "Gray", hex: "#9CA3AF" }, { k: "gold", word: "Gold", hex: "#EAB308" },
    ],
    [
      { k: "crimson", word: "Crimson", hex: "#DC143C" }, { k: "navy", word: "Navy", hex: "#1E3A8A" },
      { k: "teal", word: "Teal", hex: "#14B8A6" }, { k: "lime", word: "Lime", hex: "#84CC16" },
      { k: "maroon", word: "Maroon", hex: "#7F1D1D" }, { k: "magenta", word: "Magenta", hex: "#D946EF" },
      { k: "cyan", word: "Cyan", hex: "#06B6D4" }, { k: "olive", word: "Olive", hex: "#808000" },
      { k: "indigo", word: "Indigo", hex: "#4F46E5" }, { k: "coral", word: "Coral", hex: "#FF7F50" },
      { k: "turquoise", word: "Turquoise", hex: "#40E0D0" }, { k: "lavender", word: "Lavender", hex: "#B57EDC" },
    ],
    [
      { k: "beige", word: "Beige", hex: "#E7DCC3" }, { k: "peach", word: "Peach", hex: "#FFDAB9" },
      { k: "mint", word: "Mint", hex: "#98FF98" }, { k: "salmon", word: "Salmon", hex: "#FA8072" },
      { k: "khaki", word: "Khaki", hex: "#C3B091" }, { k: "plum", word: "Plum", hex: "#8E4585" },
      { k: "amber", word: "Amber", hex: "#F59E0B" }, { k: "rose", word: "Rose", hex: "#F43F5E" },
      { k: "ivory", word: "Ivory", hex: "#FFFFF0" }, { k: "charcoal", word: "Charcoal", hex: "#36454F" },
      { k: "mustard", word: "Mustard", hex: "#E1AD01" }, { k: "periwinkle", word: "Periwinkle", hex: "#CCCCFF" },
    ],
  ],
  animals: [
    [
      { k: "cat", word: "Cat", emoji: "🐱", sound: "meow" }, { k: "dog", word: "Dog", emoji: "🐶", sound: "woof" },
      { k: "cow", word: "Cow", emoji: "🐮", sound: "moo" }, { k: "duck", word: "Duck", emoji: "🦆", sound: "quack" },
      { k: "lion", word: "Lion", emoji: "🦁", sound: "roar" }, { k: "sheep", word: "Sheep", emoji: "🐑", sound: "baa" },
      { k: "horse", word: "Horse", emoji: "🐴", sound: "neigh" }, { k: "frog", word: "Frog", emoji: "🐸", sound: "ribbit" },
      { k: "bee", word: "Bee", emoji: "🐝", sound: "buzz" }, { k: "pig", word: "Pig", emoji: "🐷", sound: "oink" },
      { k: "monkey", word: "Monkey", emoji: "🐵", sound: "ooh ooh" }, { k: "elephant", word: "Elephant", emoji: "🐘", sound: "trumpet" },
    ],
    [
      { k: "tiger", word: "Tiger", emoji: "🐯", sound: "growl" }, { k: "bear", word: "Bear", emoji: "🐻", sound: "grr" },
      { k: "zebra", word: "Zebra", emoji: "🦓" }, { k: "giraffe", word: "Giraffe", emoji: "🦒" },
      { k: "panda", word: "Panda", emoji: "🐼" }, { k: "fox", word: "Fox", emoji: "🦊" },
      { k: "wolf", word: "Wolf", emoji: "🐺", sound: "howl" }, { k: "deer", word: "Deer", emoji: "🦌" },
      { k: "owl", word: "Owl", emoji: "🦉", sound: "hoot" }, { k: "rabbit", word: "Rabbit", emoji: "🐰" },
      { k: "goat", word: "Goat", emoji: "🐐", sound: "bleat" }, { k: "mouse", word: "Mouse", emoji: "🐭", sound: "squeak" },
    ],
    [
      { k: "penguin", word: "Penguin", emoji: "🐧" }, { k: "dolphin", word: "Dolphin", emoji: "🐬", sound: "click" },
      { k: "octopus", word: "Octopus", emoji: "🐙" }, { k: "crocodile", word: "Crocodile", emoji: "🐊", sound: "snap" },
      { k: "rhino", word: "Rhino", emoji: "🦏" }, { k: "hippo", word: "Hippo", emoji: "🦛" },
      { k: "camel", word: "Camel", emoji: "🐫" }, { k: "snake", word: "Snake", emoji: "🐍", sound: "hiss" },
      { k: "turtle", word: "Turtle", emoji: "🐢" }, { k: "squirrel", word: "Squirrel", emoji: "🐿️" },
      { k: "koala", word: "Koala", emoji: "🐨" }, { k: "peacock", word: "Peacock", emoji: "🦚" },
    ],
  ],
  words: [
    [
      { k: "cat", word: "Cat", emoji: "🐱", say: "Cat. C-A-T. Can you say cat?" },
      { k: "dog", word: "Dog", emoji: "🐶", say: "Dog. D-O-G. Can you say dog?" },
      { k: "sun", word: "Sun", emoji: "☀️", say: "Sun. S-U-N. Can you say sun?" },
      { k: "hat", word: "Hat", emoji: "🎩", say: "Hat. H-A-T. Can you say hat?" },
      { k: "ball", word: "Ball", emoji: "⚽", say: "Ball. B-A-L-L. Can you say ball?" },
      { k: "cup", word: "Cup", emoji: "🥤", say: "Cup. C-U-P. Can you say cup?" },
      { k: "book", word: "Book", emoji: "📖", say: "Book. B-O-O-K. Can you say book?" },
      { k: "car", word: "Car", emoji: "🚗", say: "Car. C-A-R. Can you say car?" },
      { k: "milk", word: "Milk", emoji: "🥛", say: "Milk. M-I-L-K. Can you say milk?" },
      { k: "bed", word: "Bed", emoji: "🛏️", say: "Bed. B-E-D. Can you say bed?" },
      { k: "fish", word: "Fish", emoji: "🐟", say: "Fish. F-I-S-H. Can you say fish?" },
      { k: "star", word: "Star", emoji: "⭐", say: "Star. S-T-A-R. Can you say star?" },
    ],
    [
      { k: "frog", word: "Frog", emoji: "🐸" }, { k: "tree", word: "Tree", emoji: "🌳" },
      { k: "ship", word: "Ship", emoji: "🚢" }, { k: "hand", word: "Hand", emoji: "✋" },
      { k: "jump", word: "Jump", emoji: "🦘" }, { k: "nest", word: "Nest", emoji: "🪺" },
      { k: "gift", word: "Gift", emoji: "🎁" }, { k: "lamp", word: "Lamp", emoji: "💡" },
      { k: "sock", word: "Sock", emoji: "🧦" }, { k: "drum", word: "Drum", emoji: "🥁" },
      { k: "flag", word: "Flag", emoji: "🚩" }, { k: "clock", word: "Clock", emoji: "🕐" },
    ],
    [
      { k: "apple", word: "Apple", emoji: "🍎" }, { k: "water", word: "Water", emoji: "💧" },
      { k: "happy", word: "Happy", emoji: "😊" }, { k: "table", word: "Table", emoji: "🪑" },
      { k: "rabbit", word: "Rabbit", emoji: "🐰" }, { k: "yellow", word: "Yellow", emoji: "🟡" },
      { k: "little", word: "Little", emoji: "🤏" }, { k: "mother", word: "Mother", emoji: "👩" },
      { k: "tiger", word: "Tiger", emoji: "🐯" }, { k: "seven", word: "Seven", emoji: "7️⃣" },
      { k: "garden", word: "Garden", emoji: "🌷" }, { k: "friend", word: "Friend", emoji: "🧒" },
    ],
  ],
  spanish: [
    [
      { k: "hola", word: "Hola", emoji: "👋", say: "Hola. That means Hello!" },
      { k: "adios", word: "Adiós", emoji: "🙋", say: "Adiós. That means Goodbye!" },
      { k: "gracias", word: "Gracias", emoji: "🙏", say: "Gracias. That means Thank you!" },
      { k: "si", word: "Sí", emoji: "👍", say: "Sí. That means Yes!" },
      { k: "no", word: "No", emoji: "👎", say: "No. That means No!" },
      { k: "uno", word: "Uno", emoji: "1️⃣", say: "Uno. That means One!" },
      { k: "dos", word: "Dos", emoji: "2️⃣", say: "Dos. That means Two!" },
      { k: "gato", word: "Gato", emoji: "🐱", say: "Gato. That means Cat!" },
      { k: "perro", word: "Perro", emoji: "🐶", say: "Perro. That means Dog!" },
      { k: "rojo", word: "Rojo", emoji: "🔴", say: "Rojo. That means Red!" },
      { k: "azul", word: "Azul", emoji: "🔵", say: "Azul. That means Blue!" },
      { k: "agua", word: "Agua", emoji: "💧", say: "Agua. That means Water!" },
    ],
    [
      { k: "tres", word: "Tres", emoji: "3️⃣", say: "Tres. That means Three!" },
      { k: "cuatro", word: "Cuatro", emoji: "4️⃣", say: "Cuatro. That means Four!" },
      { k: "cinco", word: "Cinco", emoji: "5️⃣", say: "Cinco. That means Five!" },
      { k: "verde", word: "Verde", emoji: "🟢", say: "Verde. That means Green!" },
      { k: "amarillo", word: "Amarillo", emoji: "🟡", say: "Amarillo. That means Yellow!" },
      { k: "mama", word: "Mamá", emoji: "👩", say: "Mamá. That means Mom!" },
      { k: "papa", word: "Papá", emoji: "👨", say: "Papá. That means Dad!" },
      { k: "casa", word: "Casa", emoji: "🏠", say: "Casa. That means House!" },
      { k: "sol", word: "Sol", emoji: "☀️", say: "Sol. That means Sun!" },
      { k: "luna", word: "Luna", emoji: "🌙", say: "Luna. That means Moon!" },
      { k: "leche", word: "Leche", emoji: "🥛", say: "Leche. That means Milk!" },
      { k: "pan", word: "Pan", emoji: "🍞", say: "Pan. That means Bread!" },
    ],
    [
      { k: "buenosdias", word: "Buenos días", emoji: "🌅", say: "Buenos días means Good morning!" },
      { k: "porfavor", word: "Por favor", emoji: "🙏", say: "Por favor means Please!" },
      { k: "denada", word: "De nada", emoji: "😊", say: "De nada means You're welcome!" },
      { k: "amigo", word: "Amigo", emoji: "🧒", say: "Amigo means Friend!" },
      { k: "feliz", word: "Feliz", emoji: "😄", say: "Feliz means Happy!" },
      { k: "grande", word: "Grande", emoji: "🐘", say: "Grande means Big!" },
      { k: "pequeno", word: "Pequeño", emoji: "🐭", say: "Pequeño means Small!" },
      { k: "libro", word: "Libro", emoji: "📖", say: "Libro means Book!" },
      { k: "escuela", word: "Escuela", emoji: "🏫", say: "Escuela means School!" },
      { k: "flor", word: "Flor", emoji: "🌸", say: "Flor means Flower!" },
      { k: "estrella", word: "Estrella", emoji: "⭐", say: "Estrella means Star!" },
      { k: "familia", word: "Familia", emoji: "👨‍👩‍👧", say: "Familia means Family!" },
    ],
  ],
  geography: [
    [
      { k: "earth", word: "Earth", emoji: "🌍", say: "Earth. Our home planet!" },
      { k: "ocean", word: "Ocean", emoji: "🌊", say: "Ocean. A very big body of water." },
      { k: "mountain", word: "Mountain", emoji: "⛰️", say: "Mountain. A very tall piece of land." },
      { k: "forest", word: "Forest", emoji: "🌲", say: "Forest. A place with many trees." },
      { k: "desert", word: "Desert", emoji: "🏜️", say: "Desert. A hot and sandy place." },
      { k: "river", word: "River", emoji: "🏞️", say: "River. Water that flows across the land." },
      { k: "island", word: "Island", emoji: "🏝️", say: "Island. Land with water all around it." },
      { k: "volcano", word: "Volcano", emoji: "🌋", say: "Volcano. A mountain that can erupt." },
      { k: "beach", word: "Beach", emoji: "🏖️", say: "Beach. Sand next to the sea." },
      { k: "city", word: "City", emoji: "🏙️", say: "City. A place with many buildings." },
      { k: "lake", word: "Lake", emoji: "🛶", say: "Lake. Water with land all around it." },
      { k: "cave", word: "Cave", emoji: "🕳️", say: "Cave. A hollow space inside a hill." },
    ],
    [
      { k: "africa", word: "Africa", emoji: "🌍", say: "Africa is a continent." },
      { k: "asia", word: "Asia", emoji: "🌏", say: "Asia is the biggest continent." },
      { k: "europe", word: "Europe", emoji: "🗺️", say: "Europe is a continent." },
      { k: "namerica", word: "North America", emoji: "🌎", say: "North America is a continent." },
      { k: "samerica", word: "South America", emoji: "🌎", say: "South America is a continent." },
      { k: "australia", word: "Australia", emoji: "🦘", say: "Australia is a continent." },
      { k: "antarctica", word: "Antarctica", emoji: "🧊", say: "Antarctica is icy and cold." },
      { k: "atlantic", word: "Atlantic", emoji: "🌊", say: "The Atlantic is an ocean." },
      { k: "pacific", word: "Pacific", emoji: "🌊", say: "The Pacific is the biggest ocean." },
      { k: "arctic", word: "Arctic", emoji: "❄️", say: "The Arctic Ocean is at the top of Earth." },
      { k: "indian", word: "Indian Ocean", emoji: "🌊", say: "The Indian Ocean is warm." },
      { k: "equator", word: "Equator", emoji: "🧭", say: "The Equator is a line around the middle of Earth." },
    ],
    [
      { k: "france", word: "France", emoji: "🇫🇷", say: "France. Its capital is Paris." },
      { k: "japan", word: "Japan", emoji: "🇯🇵", say: "Japan. Its capital is Tokyo." },
      { k: "egypt", word: "Egypt", emoji: "🇪🇬", say: "Egypt. Home of the pyramids." },
      { k: "brazil", word: "Brazil", emoji: "🇧🇷", say: "Brazil. Its capital is Brasília." },
      { k: "india", word: "India", emoji: "🇮🇳", say: "India. Its capital is New Delhi." },
      { k: "canada", word: "Canada", emoji: "🇨🇦", say: "Canada. Its capital is Ottawa." },
      { k: "mexico", word: "Mexico", emoji: "🇲🇽", say: "Mexico. Its capital is Mexico City." },
      { k: "italy", word: "Italy", emoji: "🇮🇹", say: "Italy. Its capital is Rome." },
      { k: "china", word: "China", emoji: "🇨🇳", say: "China. Its capital is Beijing." },
      { k: "kenya", word: "Kenya", emoji: "🇰🇪", say: "Kenya. Its capital is Nairobi." },
      { k: "spain", word: "Spain", emoji: "🇪🇸", say: "Spain. Its capital is Madrid." },
      { k: "usa", word: "USA", emoji: "🇺🇸", say: "The USA. Its capital is Washington." },
    ],
  ],
  grammar: [
    [
      { k: "noun1", word: "Naming Word", emoji: "🧸", say: "A naming word names a thing, like teddy." },
      { k: "verb1", word: "Doing Word", emoji: "🏃", say: "A doing word is an action, like run." },
      { k: "adj1", word: "Describing Word", emoji: "🌈", say: "A describing word tells us more, like colorful." },
      { k: "capital", word: "Capital Letter", emoji: "🅰️", say: "A sentence starts with a capital letter." },
      { k: "period", word: "Full Stop", emoji: "⏹️", say: "A sentence ends with a full stop." },
      { k: "question", word: "Question Mark", emoji: "❓", say: "A question ends with a question mark." },
      { k: "exclaim", word: "Exclamation Mark", emoji: "❗", say: "We use this for excited words, like Wow!" },
      { k: "comma", word: "Comma", emoji: "✒️", say: "A comma gives us a little pause." },
      { k: "spaces", word: "Word Spaces", emoji: "⬜", say: "We put spaces between words." },
      { k: "rhyme", word: "Rhyming Words", emoji: "🎶", say: "Rhyming words sound alike, like cat and hat." },
      { k: "plurals", word: "Add an S", emoji: "➕", say: "We add s for more than one, like cats." },
      { k: "and", word: "The Word And", emoji: "🔗", say: "And joins two things together." },
    ],
    [
      { k: "noun2", word: "Noun", emoji: "🧸", say: "A noun is a person, place or thing." },
      { k: "verb2", word: "Verb", emoji: "🏃", say: "A verb is an action word." },
      { k: "adj2", word: "Adjective", emoji: "🌈", say: "An adjective describes a noun." },
      { k: "pronoun", word: "Pronoun", emoji: "🙋", say: "Pronouns are words like he, she and it." },
      { k: "sentence", word: "Sentence", emoji: "📝", say: "A sentence tells a whole idea." },
      { k: "statement", word: "Statement", emoji: "✅", say: "A statement tells us something." },
      { k: "questionw", word: "Question", emoji: "❓", say: "A question asks something." },
      { k: "opposites", word: "Opposites", emoji: "↔️", say: "Opposites are different, like hot and cold." },
      { k: "singular", word: "Singular", emoji: "1️⃣", say: "Singular means just one." },
      { k: "plural", word: "Plural", emoji: "🔢", say: "Plural means more than one." },
      { k: "joining", word: "Joining Word", emoji: "🔗", say: "Joining words connect ideas, like and or but." },
      { k: "past", word: "Past Tense", emoji: "⏮️", say: "Past tense means it already happened." },
    ],
    [
      { k: "vowels", word: "Vowels", emoji: "🅰️", say: "Vowels are a, e, i, o and u." },
      { k: "consonants", word: "Consonants", emoji: "🅱️", say: "Consonants are all the other letters." },
      { k: "syllables", word: "Syllables", emoji: "👏", say: "Syllables are the beats in a word." },
      { k: "compound", word: "Compound Words", emoji: "🧩", say: "Two words joined, like sun and flower make sunflower." },
      { k: "contraction", word: "Contractions", emoji: "✂️", say: "Two words squished, like do not becomes don't." },
      { k: "article", word: "A, An, The", emoji: "🔤", say: "These little words come before nouns." },
      { k: "adverb", word: "Adverb", emoji: "⚡", say: "An adverb tells how, like quickly." },
      { k: "synonym", word: "Synonyms", emoji: "🟰", say: "Synonyms mean the same, like big and large." },
      { k: "antonym", word: "Antonyms", emoji: "↔️", say: "Antonyms are opposites, like up and down." },
      { k: "abcorder", word: "ABC Order", emoji: "🔡", say: "Putting words in alphabet order." },
      { k: "apostrophe", word: "Apostrophe", emoji: "❜", say: "An apostrophe shows something belongs, like Mia's." },
      { k: "quotation", word: "Quotation Marks", emoji: "❝", say: "These show what someone says." },
    ],
  ],
  money: [
    [
      { k: "penny", word: "Penny", emoji: "🪙", say: "A penny is one cent." },
      { k: "nickel", word: "Nickel", emoji: "🪙", say: "A nickel is five cents." },
      { k: "dime", word: "Dime", emoji: "🪙", say: "A dime is ten cents." },
      { k: "quarter", word: "Quarter", emoji: "🪙", say: "A quarter is twenty five cents." },
      { k: "dollar", word: "Dollar", emoji: "💵", say: "A dollar is one hundred cents." },
      { k: "coin", word: "Coin", emoji: "🪙", say: "A coin is metal money." },
      { k: "bill", word: "Bill", emoji: "💵", say: "A bill is paper money." },
      { k: "save", word: "Save", emoji: "🐷", say: "Saving means keeping money for later." },
      { k: "spend", word: "Spend", emoji: "🛒", say: "Spending means using money to buy things." },
      { k: "buy", word: "Buy", emoji: "🛍️", say: "To buy is to get something with money." },
      { k: "cost", word: "Cost", emoji: "🏷️", say: "The cost is how much something is." },
      { k: "earn", word: "Earn", emoji: "💪", say: "You earn money by doing work." },
    ],
    [
      { k: "fivedollars", word: "Five Dollars", emoji: "💵", say: "Five dollars is five one-dollar bills." },
      { k: "tendollars", word: "Ten Dollars", emoji: "💵", say: "Ten dollars is two five-dollar bills." },
      { k: "twenty", word: "Twenty Dollars", emoji: "💵", say: "Twenty dollars is a bigger bill." },
      { k: "price", word: "Price", emoji: "🏷️", say: "The price is what you pay." },
      { k: "change", word: "Change", emoji: "🔁", say: "Change is money you get back." },
      { k: "budget", word: "Budget", emoji: "📊", say: "A budget is a plan for money." },
      { k: "needs", word: "Needs", emoji: "🍎", say: "Needs are things we must have, like food." },
      { k: "wants", word: "Wants", emoji: "🎮", say: "Wants are things that are nice to have." },
      { k: "bank", word: "Bank", emoji: "🏦", say: "A bank keeps your money safe." },
      { k: "borrow", word: "Borrow", emoji: "🤝", say: "To borrow is to use and give back." },
      { k: "lend", word: "Lend", emoji: "🫴", say: "To lend is to let someone borrow." },
      { k: "value", word: "Value", emoji: "⭐", say: "Value is how much something is worth." },
    ],
    [
      { k: "income", word: "Income", emoji: "⬆️", say: "Income is money coming in." },
      { k: "expense", word: "Expense", emoji: "⬇️", say: "An expense is money going out." },
      { k: "goal", word: "Savings Goal", emoji: "🎯", say: "A savings goal is what you save for." },
      { k: "credit", word: "Credit", emoji: "💳", say: "Credit means paying later." },
      { k: "debit", word: "Debit", emoji: "💳", say: "Debit uses money you already have." },
      { k: "interest", word: "Interest", emoji: "📈", say: "Interest is extra money the bank adds." },
      { k: "invest", word: "Invest", emoji: "🌱", say: "Investing helps money grow over time." },
      { k: "donate", word: "Donate", emoji: "❤️", say: "Donating is giving money to help others." },
      { k: "discount", word: "Discount", emoji: "🔖", say: "A discount means a lower price." },
      { k: "receipt", word: "Receipt", emoji: "🧾", say: "A receipt shows what you bought." },
      { k: "tax", word: "Tax", emoji: "🏛️", say: "Tax is money we pay to help everyone." },
      { k: "allowance", word: "Allowance", emoji: "💰", say: "An allowance is money you get regularly." },
    ],
  ],
  team: [
    [
      { k: "share", word: "Share", emoji: "🤝", say: "Sharing means letting others have a turn." },
      { k: "help", word: "Help", emoji: "🙌", say: "Helping means lending a hand." },
      { k: "kind", word: "Be Kind", emoji: "😊", say: "Being kind makes friends feel good." },
      { k: "listen", word: "Listen", emoji: "👂", say: "Listening means hearing what others say." },
      { k: "turns", word: "Take Turns", emoji: "🔄", say: "Taking turns means we all get a chance." },
      { k: "please", word: "Say Please", emoji: "🙏", say: "We say please when we ask for something." },
      { k: "thanks", word: "Say Thank You", emoji: "💛", say: "We say thank you to be polite." },
      { k: "friend", word: "Friends", emoji: "👫", say: "Friends play and share together." },
      { k: "wait", word: "Wait", emoji: "⏳", say: "Waiting patiently is kind." },
      { k: "sorry", word: "Say Sorry", emoji: "😔", say: "We say sorry when we make a mistake." },
      { k: "smile", word: "Smile", emoji: "😄", say: "A smile makes everyone happy." },
      { k: "hug", word: "Hug", emoji: "🤗", say: "A hug shows we care." },
    ],
    [
      { k: "teamwork", word: "Teamwork", emoji: "👥", say: "Teamwork means working together." },
      { k: "cooperate", word: "Cooperate", emoji: "🤝", say: "Cooperating means helping each other." },
      { k: "patience", word: "Patience", emoji: "🕰️", say: "Patience means waiting calmly." },
      { k: "honest", word: "Be Honest", emoji: "💯", say: "Being honest means telling the truth." },
      { k: "respect", word: "Respect", emoji: "🙇", say: "Respect means being kind to everyone." },
      { k: "encourage", word: "Encourage", emoji: "📣", say: "Encouraging means cheering others on." },
      { k: "apologize", word: "Apologize", emoji: "🙏", say: "To apologize is to say you're sorry." },
      { k: "forgive", word: "Forgive", emoji: "💗", say: "Forgiving means letting go of hurt." },
      { k: "include", word: "Include", emoji: "🫂", say: "Including means letting everyone join." },
      { k: "cheer", word: "Cheer", emoji: "🎉", say: "Cheering makes others feel proud." },
      { k: "calm", word: "Stay Calm", emoji: "😌", say: "Staying calm helps us think clearly." },
      { k: "askhelp", word: "Ask For Help", emoji: "🆘", say: "It's okay to ask for help." },
    ],
    [
      { k: "leader", word: "Be a Leader", emoji: "⭐", say: "A leader helps guide the team." },
      { k: "helper", word: "Be a Helper", emoji: "🫶", say: "A helper supports the team." },
      { k: "compromise", word: "Compromise", emoji: "⚖️", say: "Compromise means meeting in the middle." },
      { k: "empathy", word: "Empathy", emoji: "💞", say: "Empathy means feeling how others feel." },
      { k: "responsible", word: "Responsibility", emoji: "✅", say: "Being responsible means doing your part." },
      { k: "solve", word: "Solve Problems", emoji: "🧩", say: "We can solve problems together." },
      { k: "communicate", word: "Communicate", emoji: "💬", say: "Communicating means sharing ideas." },
      { k: "trust", word: "Trust", emoji: "🤞", say: "Trust means believing in each other." },
      { k: "fairplay", word: "Play Fair", emoji: "🎯", say: "Playing fair means following the rules." },
      { k: "celebrate", word: "Celebrate Others", emoji: "🥳", say: "We cheer when others do well." },
      { k: "feelings", word: "Handle Feelings", emoji: "🎭", say: "We can share our feelings calmly." },
      { k: "brave", word: "Be Brave", emoji: "🦁", say: "Being brave means trying even when it's hard." },
    ],
  ],
  creativity: [
    [
      { k: "draw", word: "Draw", emoji: "✏️", say: "Drawing makes pictures with lines." },
      { k: "paint", word: "Paint", emoji: "🎨", say: "Painting uses colors and a brush." },
      { k: "sing", word: "Sing", emoji: "🎤", say: "Singing makes music with your voice." },
      { k: "dance", word: "Dance", emoji: "💃", say: "Dancing moves your body to music." },
      { k: "build", word: "Build", emoji: "🧱", say: "Building makes things with blocks." },
      { k: "imagine", word: "Imagine", emoji: "💭", say: "Imagining is dreaming up new ideas." },
      { k: "color", word: "Color", emoji: "🖍️", say: "Coloring fills pictures with color." },
      { k: "music", word: "Music", emoji: "🎵", say: "Music is fun sounds and rhythm." },
      { k: "craft", word: "Craft", emoji: "✂️", say: "Crafting makes things with your hands." },
      { k: "story", word: "Story", emoji: "📖", say: "A story shares an adventure." },
      { k: "pretend", word: "Pretend", emoji: "🎭", say: "Pretending is playing make-believe." },
      { k: "clay", word: "Clay", emoji: "🟤", say: "Clay can be shaped into anything." },
    ],
    [
      { k: "sculpt", word: "Sculpt", emoji: "🗿", say: "Sculpting shapes clay into figures." },
      { k: "collage", word: "Collage", emoji: "🖼️", say: "A collage glues many pieces together." },
      { k: "rhythm", word: "Rhythm", emoji: "🥁", say: "Rhythm is a beat you can clap." },
      { k: "melody", word: "Melody", emoji: "🎶", say: "A melody is a tune you can hum." },
      { k: "costume", word: "Costume", emoji: "👗", say: "A costume helps you play a character." },
      { k: "puppet", word: "Puppet", emoji: "🧦", say: "A puppet tells stories with your hand." },
      { k: "origami", word: "Origami", emoji: "📄", say: "Origami folds paper into shapes." },
      { k: "design", word: "Design", emoji: "📐", say: "Designing is planning how to make something." },
      { k: "doodle", word: "Doodle", emoji: "✏️", say: "A doodle is a fun little drawing." },
      { k: "act", word: "Act", emoji: "🎬", say: "Acting is pretending to be someone." },
      { k: "compose", word: "Compose", emoji: "🎼", say: "Composing is making your own music." },
      { k: "invent", word: "Invent", emoji: "💡", say: "Inventing is creating something new." },
    ],
    [
      { k: "sketch", word: "Sketch", emoji: "🖌️", say: "A sketch is a quick drawing." },
      { k: "watercolor", word: "Watercolor", emoji: "🎨", say: "Watercolor paints with water and color." },
      { k: "harmony", word: "Harmony", emoji: "🎵", say: "Harmony is notes that sound nice together." },
      { k: "routine", word: "Dance Routine", emoji: "🩰", say: "A routine is dance steps in order." },
      { k: "animation", word: "Animation", emoji: "🎞️", say: "Animation makes drawings move." },
      { k: "pottery", word: "Pottery", emoji: "🏺", say: "Pottery makes bowls from clay." },
      { k: "photography", word: "Photography", emoji: "📷", say: "Photography captures pictures with a camera." },
      { k: "poetry", word: "Poetry", emoji: "📜", say: "Poetry uses fun, rhythmic words." },
      { k: "mural", word: "Mural", emoji: "🧱", say: "A mural is a giant painting on a wall." },
      { k: "remix", word: "Remix", emoji: "🔀", say: "A remix mixes ideas in a new way." },
      { k: "improvise", word: "Improvise", emoji: "🎷", say: "To improvise is to make it up as you go." },
      { k: "brainstorm", word: "Brainstorm", emoji: "🧠", say: "Brainstorming is thinking of lots of ideas." },
    ],
  ],
};

export function getItems(category, level = 1) {
  const levels = LEVELS[category];
  if (!levels) return [];
  const idx = Math.min(Math.max(level, 1), levels.length) - 1;
  return levels[idx];
}

export function speechText(category, item) {
  if (item.say) return item.say;
  if (category === "alphabet") return `${item.k}. ${item.k} is for ${item.word}`;
  if (category === "numbers") return `${item.word}. ${item.k}`;
  if (category === "animals" && item.sound) return `${item.word}. The ${item.word} says ${item.sound}`;
  if (category === "colors") return `${item.word}`;
  return item.word;
}
